import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDurationSeconds, formatIsoDateTime } from '@/lib/sapJobStatus';

export default function SapJobTimingPanel({ timingProfile, timingMissing }) {
  return (
    <Card data-testid="sap-job-timing-tab">
      <CardHeader>
        <CardTitle>Timing profile</CardTitle>
        <CardDescription>
          HALO uses recent successful runs to estimate when this job normally starts and finishes.
        </CardDescription>
      </CardHeader>
      <CardContent className="text-sm">
        {timingMissing || !timingProfile ? (
          <p className="text-muted-foreground" data-testid="timing-profile-missing">
            Not enough historical data yet
          </p>
        ) : (
          <div className="grid gap-2 sm:grid-cols-2">
            <div>Sample count: {timingProfile.sample_count ?? '—'}</div>
            <div>Median start delay: {formatDurationSeconds(timingProfile.median_start_delay_seconds)}</div>
            <div>Median runtime: {formatDurationSeconds(timingProfile.median_runtime_seconds)}</div>
            <div>P90 runtime: {formatDurationSeconds(timingProfile.p90_runtime_seconds)}</div>
            <div>Min runtime: {formatDurationSeconds(timingProfile.min_runtime_seconds)}</div>
            <div>Max runtime: {formatDurationSeconds(timingProfile.max_runtime_seconds)}</div>
            <div className="sm:col-span-2">
              Calculated at: {formatIsoDateTime(timingProfile.calculated_at)}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
